module.exports = __webpack_public_path__ + "img/fechar-icon-verde.023d4316.svg";